import React from "react";
import type { HomeChargingType } from "../../../../../../../../common-deprecated/types/SettingsType";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import type { ExtraType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import HomeCharger from "./HomeCharger";
import styles from "./Charging.module.scss";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { useCarConfigOptionalLabel } from "../../../../../utils/labelUtils";

type ChargingAtHomeProps = {
    chargingAceData: HomeChargingType | null;
    homechargers: ExtraType[];
};

const ChargingAtHome: React.FC<ChargingAtHomeProps> = (props) => {
    const { chargingAceData, homechargers } = props;

    const [homeChargerDisclaimerLabel, carConfigHomeChargeInstallation, carConfigCalculateChargingTimeAndRange] =
        useCarConfigOptionalLabel([
            "carConfigHomeChargerDisclaimer",
            "carConfigHomeChargeInstallation",
            "carConfigCalculateChargingTimeAndRange",
        ]);

    return (
        <>
            <div>
                <Text variant="apheleia-h5" spacing="spacing-4">
                    {homeChargerDisclaimerLabel}
                </Text>
            </div>

            <div className={styles.items}>
                {homechargers.map((homeCharger) => (
                    <div key={homeCharger.id}>
                        <HomeCharger {...homeCharger} />
                    </div>
                ))}

                {(chargingAceData?.homeChargingUrl || chargingAceData?.homeChargingTimeAndRangeUrl) && (
                    <div>
                        <div className={styles.box}>
                            {chargingAceData.homeChargingLearnMore && (
                                <Text variant="apheleia-h5" spacing="spacing-2">
                                    {chargingAceData.homeChargingLearnMore}
                                </Text>
                            )}
                            {/* Role list needed for accessibility (mainly in safari)*/}
                            {/* eslint-disable-next-line jsx-a11y/no-redundant-roles*/}
                            <ul className={styles.actions} role="list">
                                <li>
                                    <Button
                                        variant="apheleia-text"
                                        href={chargingAceData.homeChargingUrl}
                                        target="_blank"
                                    >
                                        {carConfigHomeChargeInstallation}
                                        <Icon variant="external" sizing="sm" aria-hidden="true" />
                                    </Button>
                                </li>
                                <li>
                                    <Button
                                        variant="apheleia-text"
                                        href={chargingAceData.homeChargingTimeAndRangeUrl}
                                        target="_blank"
                                    >
                                        {carConfigCalculateChargingTimeAndRange}
                                        <Icon variant="external" sizing="sm" aria-hidden="true" />
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ChargingAtHome;
